module.exports = __webpack_public_path__ + "static/media/faq.bdc96b75.md";